const messagesConst = {
    between: {
        max: '{{attributeName}} should be less than or equal to {{max}}',
        min: '{{attributeName}} should be greater than or equal to {{min}}'
    }
};

class MessagesHelper {
    // eslint-disable-next-line class-methods-use-this
    getErrorMessages(attributeName, attributeField, validation) {
        if (!validation[attributeField].$invalid) return '';

        const messages = [];

        Object.entries(validation[attributeField].$params)
            .forEach(([key, properties]) => {
                if (!validation[attributeField][key]) {
                    switch (key) {
                    case ('between'): {
                        const value = parseFloat(validation[attributeField].$model);
                        if (value > properties.max) {
                            messages.push((messagesConst)[key].max.replace('{{attributeName}}', attributeName)
                                .replace('{{max}}', properties.max));
                        } else {
                            messages.push((messagesConst)[key].min.replace('{{attributeName}}', attributeName)
                                .replace('{{min}}', properties.min));
                        }
                        break;
                    }
                    default:
                        if ((messagesConst)[key]) {
                            messages.push((messagesConst)[key].replace('{{attributeName}}', attributeName));
                        }
                        break;
                    }
                }
            });
        return messages;
    }
}

export default new MessagesHelper();
